import request from '@/utils/request'

/**
 * 获取共享文件列表
 */
 export function getShareFileList(params = { page: 1, size: 10 }) {
    return request({
      url: '/share/list',
      method: 'get',
      params
    })
  }